// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"w0","title":"w1","year":"w2","genres":"w3","buttonWrapper":"w4","button":"w5 zV"};